<div class="flex-1 bg-slate-50/50 p-1 overflow-hidden flex flex-col h-full">
    <!-- Global Overlay for Filter Popup -->
    @if (activeFilterColumn()) {
    <div class="fixed inset-0 z-30" (click)="closeFilterPopup()"></div>
    }

    <div class="w-full h-full flex flex-col px-1">
        <!-- Header -->
        <header class="mb-2 flex justify-between items-center shrink-0 pt-2">
            <div class="flex items-center gap-4">
                <div>
                    <h1 class="text-lg font-bold text-slate-800 leading-tight">Importação de Demandas</h1>
                    <p class="text-[10px] text-slate-500">Gerenciamento de arquivos de demanda do MRP</p>
                </div>
            </div>
            <div class="flex gap-2 items-center">
                @if (hasActiveFilters()) {
                <button (click)="clearAllFilters()"
                    class="flex items-center gap-1 px-2 py-1 text-[10px] font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                    title="Remover todos os filtros">
                    <lucide-icon [img]="icons.FilterX" class="w-3.5 h-3.5"></lucide-icon>
                    Limpar Filtros
                </button>
                }
                <button (click)="loadData()"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm"
                    [disabled]="loading()">
                    <lucide-icon [img]="icons.RefreshCw"
                        [class]="'w-3.5 h-3.5' + (loading() ? ' animate-spin' : '')"></lucide-icon>
                    Atualizar
                </button>
            </div>
        </header>

        <!-- Grid -->
        <div class="bg-white rounded-xl shadow-sm border border-slate-200 relative flex-1 min-h-0 flex flex-col overflow-hidden">

            <!-- Loading Overlay -->
            @if (loading()) {
            <div class="absolute inset-0 bg-white/70 z-30 flex items-center justify-center">
                <div class="flex flex-col items-center gap-2">
                    <lucide-icon [img]="icons.Loader" class="w-6 h-6 text-indigo-500 animate-spin"></lucide-icon>
                    <span class="text-xs text-slate-500 font-medium">Carregando...</span>
                </div>
            </div>
            }

            <!-- Error State -->
            @if (error()) {
            <div class="absolute inset-0 bg-white z-30 flex items-center justify-center">
                <div class="flex flex-col items-center gap-3 text-center">
                    <div class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center border border-red-200">
                        <lucide-icon [img]="icons.AlertOctagon" class="w-6 h-6 text-red-500"></lucide-icon>
                    </div>
                    <p class="text-sm text-slate-600">{{ error() }}</p>
                    <button (click)="loadData()"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm">
                        <lucide-icon [img]="icons.RefreshCw" class="w-3.5 h-3.5"></lucide-icon>
                        Tentar novamente
                    </button>
                </div>
            </div>
            }

            <div class="overflow-auto flex-1">
                <table class="w-full text-left border-collapse whitespace-nowrap table-fixed min-w-[900px] transition-opacity duration-300">
                    <thead class="sticky top-0 shadow-sm" [style.z-index]="activeFilterColumn() ? 40 : 20">
                        <tr class="bg-slate-50 border-b border-slate-200">

                            <!-- Col: Arquivo -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[30%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'fileName' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Arquivo</span>
                                    <button (click)="toggleFilterPopup('fileName', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterFileName()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'fileName') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Arquivo</span>
                                    </div>
                                    <input type="text" [value]="filterFileName()"
                                        (input)="filterFileName.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('fileName')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Col: Cód. Demanda -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[20%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'demandCode' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Cód. Demanda</span>
                                    <button (click)="toggleFilterPopup('demandCode', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterDemandCode()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'demandCode') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Cód. Demanda</span>
                                    </div>
                                    <input type="text" [value]="filterDemandCode()"
                                        (input)="filterDemandCode.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('demandCode')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Col: Status -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[20%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'status' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Status</span>
                                    <button (click)="toggleFilterPopup('status', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterStatusValues().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'status') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Status</span>
                                    </div>
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllStatuses()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearStatusSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="border border-slate-100 rounded-lg">
                                        @for (opt of statusOptions; track opt.value) {
                                        <label class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterStatusValues().has(opt.value)"
                                                (change)="toggleStatusFilter(opt.value)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span>{{ opt.label }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterStatusValues().size }} selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('status')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Col: Data -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[15%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'createdAt' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Data</span>
                                    <button (click)="toggleFilterPopup('createdAt', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterDateStart() || filterDateEnd()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'createdAt') {
                                <div class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default overflow-hidden"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar por Período</span>
                                    </div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <label class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">De</label>
                                        <input type="date" [value]="filterDateStart()"
                                            (input)="filterDateStart.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex items-center gap-2 mb-3">
                                        <label class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">Até</label>
                                        <input type="date" [value]="filterDateEnd()"
                                            (input)="filterDateEnd.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('createdAt')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Col: Ações -->
                            <th class="p-2 align-middle w-[15%] sticky top-0 text-center">
                                <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Ações</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        @if (filteredImports().length === 0 && !loading()) {
                        <tr>
                            <td colspan="5" class="p-8 text-center text-slate-400 text-sm">Nenhum registro encontrado.</td>
                        </tr>
                        }
                        @for (item of filteredImports(); track item.uuid) {
                        <tr class="hover:bg-slate-50 transition-colors text-sm text-slate-700">
                            <!-- Arquivo -->
                            <td class="p-2 truncate" [title]="item.fileName">
                                <div class="flex items-center gap-1.5">
                                    <lucide-icon [img]="icons.FileText" class="w-3.5 h-3.5 text-indigo-400 shrink-0"></lucide-icon>
                                    <span class="font-mono font-medium text-slate-700 truncate">{{ item.fileName }}</span>
                                </div>
                            </td>
                            <!-- Cód. Demanda -->
                            <td class="p-2">
                                <span class="font-mono text-[13px] text-slate-600">{{ item.demandCode || '—' }}</span>
                            </td>
                            <!-- Status -->
                            <td class="p-2">
                                <span [class]="'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-bold border shadow-sm whitespace-nowrap ' + getStatusColor(item.status)">
                                    <lucide-icon [img]="getStatusIcon(item.status)"
                                        [class]="'w-3 h-3 shrink-0' + (item.status === 'PROCESSING' ? ' animate-spin-slow' : '')"></lucide-icon>
                                    {{ getStatusLabel(item.status) }}
                                </span>
                            </td>
                            <!-- Data -->
                            <td class="p-2 text-[13px] text-slate-600">{{ formatDate(item.createdAt) }}</td>
                            <!-- Ações -->
                            <td class="p-2 text-center">
                                <div class="flex items-center justify-center gap-1.5">
                                    @if (item.status === 'IMPORTED' && authService.hasRole(['Admin', 'Operator'])) {
                                    <button (click)="openScheduleModal(item)"
                                        class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[10px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm"
                                        title="Agendar importação">
                                        <lucide-icon [img]="icons.Send" class="w-3 h-3 shrink-0"></lucide-icon>
                                        Agendar
                                    </button>
                                    } @else {
                                    <button (click)="openDetails(item)"
                                        class="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-100 active:scale-95 transition-all cursor-pointer border border-indigo-200"
                                        title="Ver detalhes">
                                        <lucide-icon [img]="icons.Eye" class="w-3.5 h-3.5"></lucide-icon>
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <!-- Footer -->
            <div class="px-3 py-1.5 bg-slate-50 border-t border-slate-200 text-[10px] text-slate-500 font-medium flex justify-between items-center shrink-0">
                <span>Total: <b class="text-slate-700">{{ filteredImports().length }}</b> registros</span>
            </div>
        </div>
    </div>

    <!-- ===================== SCHEDULE MODAL ===================== -->
    @if (scheduleModalImport(); as modalImport) {
    <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden z-[102] relative animate-slide-up">
            <!-- Header -->
            <div class="p-4 border-b border-slate-200">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                        <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/20">
                            <lucide-icon [img]="icons.Send" class="w-4 h-4"></lucide-icon>
                        </div>
                        <div>
                            <h3 class="text-sm font-bold text-slate-800">Agendar Importação</h3>
                            <p class="text-[10px] text-slate-500 font-mono truncate max-w-[250px]">{{ modalImport.fileName }}</p>
                        </div>
                    </div>
                    <button (click)="closeScheduleModal()"
                        class="w-7 h-7 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors cursor-pointer">
                        <lucide-icon [img]="icons.X" class="w-3.5 h-3.5 text-slate-500"></lucide-icon>
                    </button>
                </div>
            </div>
            <!-- Body -->
            <div class="p-4 max-h-[50vh] overflow-auto detail-scroll">
                <p class="text-xs text-slate-600 mb-3 font-medium">Selecione um código de demanda:</p>

                @if (activeCodesLoading()) {
                <div class="flex flex-col items-center justify-center py-8 gap-2">
                    <lucide-icon [img]="icons.Loader" class="w-6 h-6 text-indigo-500 animate-spin"></lucide-icon>
                    <span class="text-xs text-slate-500">Carregando códigos...</span>
                </div>
                } @else {
                <div class="space-y-1.5 mb-3">
                    @for (code of activeCodes(); track code.code) {
                    <button (click)="selectDemandCode(code.code)" [disabled]="scheduling()"
                        [class]="'w-full text-left px-3 py-2.5 rounded-xl border-2 transition-all cursor-pointer ' +
                            (selectedDemandCode() === code.code
                                ? 'border-indigo-500 bg-indigo-50/50 shadow-sm'
                                : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50')">
                        <div class="flex items-center justify-between">
                            <div>
                                <span class="text-xs font-bold font-mono text-slate-800">{{ code.code }}</span>
                                <p class="text-[10px] text-slate-500 mt-0.5">
                                    {{ formatDateOnly(code.startDate) }} → {{ formatDateOnly(code.endDate) }}
                                </p>
                            </div>
                            @if (selectedDemandCode() === code.code) {
                            <div class="w-5 h-5 rounded-full bg-indigo-600 flex items-center justify-center">
                                <lucide-icon [img]="icons.Check" class="w-3 h-3 text-white"></lucide-icon>
                            </div>
                            }
                        </div>
                    </button>
                    }
                    @if (activeCodes().length === 0) {
                    <p class="text-xs text-slate-400 text-center py-4">Nenhum código de demanda ativo encontrado.</p>
                    }
                </div>

                <!-- Novo Código (disabled) -->
                <button disabled
                    class="w-full flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg border-2 border-dashed border-slate-200 text-slate-400 text-[11px] font-medium cursor-not-allowed opacity-60"
                    title="Em breve">
                    <lucide-icon [img]="icons.Plus" class="w-3 h-3"></lucide-icon>
                    Novo Código (em breve)
                </button>
                }

                <!-- Schedule Error -->
                @if (scheduleError()) {
                <div class="mt-3 p-2.5 bg-red-50 border border-red-200 rounded-lg">
                    <div class="flex items-start gap-2">
                        <lucide-icon [img]="icons.AlertOctagon" class="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5"></lucide-icon>
                        <p class="text-[11px] text-red-600 leading-relaxed">{{ scheduleError() }}</p>
                    </div>
                </div>
                }
            </div>
            <!-- Footer -->
            <div class="p-4 border-t border-slate-200 flex justify-end gap-2">
                <button (click)="closeScheduleModal()" [disabled]="scheduling()"
                    class="px-4 py-2 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors cursor-pointer">
                    Cancelar
                </button>
                <button (click)="confirmSchedule()" [disabled]="!selectedDemandCode() || scheduling()"
                    class="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100">
                    @if (scheduling()) {
                    <lucide-icon [img]="icons.Loader" class="w-3.5 h-3.5 animate-spin"></lucide-icon>
                    Agendando...
                    } @else {
                    <lucide-icon [img]="icons.Send" class="w-3.5 h-3.5"></lucide-icon>
                    Confirmar Agendamento
                    }
                </button>
            </div>
        </div>
    </div>
    }

    <!-- ===================== DETAILS MODAL ===================== -->
    @if (isDetailsModalOpen) {
    <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fade-in">

        <!-- Detail filter overlay -->
        @if (activeDetailFilter()) {
        <div class="fixed inset-0 z-[101]" (click)="closeDetailFilterPopup()"></div>
        }

        <div class="bg-white rounded-2xl shadow-2xl max-w-4xl w-full h-[85vh] overflow-hidden z-[102] relative flex flex-col animate-slide-up">
            <!-- Header -->
            <div class="p-4 border-b border-slate-200 shrink-0">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                        <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/20">
                            <lucide-icon [img]="icons.Package" class="w-4 h-4"></lucide-icon>
                        </div>
                        <div>
                            <h3 class="text-sm font-bold text-slate-800">Detalhes da Importação</h3>
                            <div class="flex items-center gap-2 text-[10px] text-slate-500">
                                @if (selectedImport(); as imp) {
                                <span class="font-mono">{{ imp.fileName }}</span>
                                @if (imp.demandCode) {
                                <span class="text-slate-300">|</span>
                                <span class="font-mono font-bold text-indigo-600">{{ imp.demandCode }}</span>
                                }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        @if (isPollingActive()) {
                        <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-bold bg-blue-50 text-blue-600 border border-blue-200 animate-pulse-glow">
                            <lucide-icon [img]="icons.RefreshCw" class="w-2.5 h-2.5 animate-spin"></lucide-icon>
                            Atualizando
                        </span>
                        }
                        <button (click)="closeDetails()"
                            class="w-7 h-7 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors cursor-pointer">
                            <lucide-icon [img]="icons.X" class="w-3.5 h-3.5 text-slate-500"></lucide-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Body -->
            <div class="flex-1 overflow-auto p-4 min-h-0 detail-scroll">

                <!-- Loading -->
                @if (branchesLoading() && branches().length === 0) {
                <div class="flex flex-col items-center justify-center py-12 gap-3">
                    <lucide-icon [img]="icons.Loader" class="w-8 h-8 text-indigo-500 animate-spin"></lucide-icon>
                    <span class="text-sm text-slate-500">Carregando filiais...</span>
                </div>
                }

                <!-- Error -->
                @if (branchesError()) {
                <div class="flex flex-col items-center justify-center py-12 gap-3">
                    <div class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center border border-red-200">
                        <lucide-icon [img]="icons.AlertOctagon" class="w-6 h-6 text-red-500"></lucide-icon>
                    </div>
                    <p class="text-sm text-slate-600">{{ branchesError() }}</p>
                </div>
                }

                <!-- Content -->
                @if (branches().length > 0) {

                <!-- Progress Bar -->
                <div class="mb-4 rounded-xl border border-slate-200 bg-slate-50/50 p-3">
                    <div class="flex items-center justify-between mb-2">
                        <span class="text-xs font-bold text-slate-700">Progresso</span>
                        <span class="text-xs font-bold text-slate-600">{{ successPercentage() }}%</span>
                    </div>
                    <div class="progress-bar-track bg-slate-200 mb-2">
                        <div [class]="'progress-bar-fill ' + getProgressBarColor(successPercentage())"
                            [style.width.%]="successPercentage()"></div>
                    </div>
                    <div class="flex gap-2 flex-wrap">
                        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200">
                            <lucide-icon [img]="icons.Check" class="w-2 h-2"></lucide-icon>
                            {{ branchCounts().success }} Sucesso
                        </span>
                        @if (branchCounts().error > 0) {
                        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-red-50 text-red-700 border border-red-200">
                            <lucide-icon [img]="icons.AlertOctagon" class="w-2 h-2"></lucide-icon>
                            {{ branchCounts().error }} Erro
                        </span>
                        }
                        @if (branchCounts().pending > 0) {
                        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-slate-50 text-slate-600 border border-slate-200">
                            <lucide-icon [img]="icons.Clock" class="w-2 h-2"></lucide-icon>
                            {{ branchCounts().pending }} Pendente
                        </span>
                        }
                        @if (branchCounts().processing > 0) {
                        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-blue-50 text-blue-700 border border-blue-200">
                            <lucide-icon [img]="icons.Loader" class="w-2 h-2 animate-spin"></lucide-icon>
                            {{ branchCounts().processing }} Processando
                        </span>
                        }
                    </div>
                </div>

                <!-- Detail Filters + Clear -->
                <div class="mb-2 flex items-center justify-between flex-wrap gap-1">
                    <div class="flex gap-2 relative">
                        <!-- Branch Code Filter -->
                        <div class="relative">
                            <button (click)="toggleDetailFilterPopup('branchCode', $event)"
                                class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-semibold border transition-colors"
                                [class]="detailBranchFilter() ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'">
                                <lucide-icon [img]="icons.Filter" class="w-2.5 h-2.5"></lucide-icon>
                                Filial
                                @if (detailBranchFilter()) {
                                <span class="bg-indigo-600 text-white text-[8px] px-1 py-0.5 rounded-full font-bold">1</span>
                                }
                            </button>
                            @if (activeDetailFilter() === 'branchCode') {
                            <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-[110] text-left cursor-default"
                                (click)="$event.stopPropagation()">
                                <div class="flex items-center gap-2 mb-3">
                                    <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                    <span class="text-xs font-bold text-slate-700">Filtrar por Filial</span>
                                </div>
                                <input type="text" [value]="detailBranchFilter()"
                                    (input)="detailBranchFilter.set($any($event.target).value)"
                                    class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                    placeholder="Código da filial...">
                                <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                    <button (click)="clearDetailBranchFilter()"
                                        class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                    <button (click)="closeDetailFilterPopup()"
                                        class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                </div>
                            </div>
                            }
                        </div>
                        <!-- Status Filter -->
                        <div class="relative">
                            <button (click)="toggleDetailFilterPopup('status', $event)"
                                class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-semibold border transition-colors"
                                [class]="detailStatusFilter().size > 0 ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'">
                                <lucide-icon [img]="icons.Filter" class="w-2.5 h-2.5"></lucide-icon>
                                Status
                                @if (detailStatusFilter().size > 0) {
                                <span class="bg-indigo-600 text-white text-[8px] px-1 py-0.5 rounded-full font-bold">{{ detailStatusFilter().size }}</span>
                                }
                            </button>
                            @if (activeDetailFilter() === 'status') {
                            <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-[110] text-left cursor-default"
                                (click)="$event.stopPropagation()">
                                <div class="flex items-center gap-2 mb-2">
                                    <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                    <span class="text-xs font-bold text-slate-700">Filtrar Status</span>
                                </div>
                                <div class="border border-slate-100 rounded-lg">
                                    @for (opt of detailBranchStatusOptions; track opt.value) {
                                    <label class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                        <input type="checkbox" [checked]="detailStatusFilter().has(opt.value)"
                                            (change)="toggleDetailStatusFilter(opt.value)"
                                            class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                        <span>{{ opt.label }}</span>
                                    </label>
                                    }
                                </div>
                                <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                    <span class="text-[10px] text-slate-400">{{ detailStatusFilter().size }} selecionado(s)</span>
                                    <div class="flex gap-2">
                                        <button (click)="clearDetailStatusFilter()"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeDetailFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    @if (hasActiveDetailFilters()) {
                    <button (click)="clearAllDetailFilters()"
                        class="flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                        title="Limpar filtros">
                        <lucide-icon [img]="icons.FilterX" class="w-2.5 h-2.5"></lucide-icon>
                        Limpar
                    </button>
                    }
                </div>

                <!-- Branches List -->
                <div class="space-y-1">
                    @if (filteredBranches().length === 0) {
                    <div class="p-4 text-center text-slate-400 text-xs">
                        Nenhuma filial encontrada para os filtros aplicados.
                    </div>
                    }
                    @for (branch of filteredBranches(); track branch.uuid) {
                    <div [class]="'rounded-lg border px-3 py-2 transition-all ' + getBranchRowColor(branch.status)">
                        <div class="flex items-center justify-between cursor-pointer" (click)="toggleBranchExpand(branch)">
                            <div class="flex items-center gap-2 min-w-0 flex-1">
                                <!-- Expand Icon -->
                                <lucide-icon [img]="expandedBranch() === branch.uuid ? icons.ChevronDown : icons.ChevronRight"
                                    class="w-3 h-3 text-slate-400 shrink-0"></lucide-icon>
                                <!-- Status Icon -->
                                <div [class]="'w-5 h-5 rounded flex items-center justify-center shrink-0 ' + getBranchIconBg(branch.status)">
                                    <lucide-icon [img]="getBranchStatusIcon(branch.status)"
                                        [class]="'w-3 h-3' + (branch.status === 'PROCESSING' ? ' animate-spin-slow' : '')"></lucide-icon>
                                </div>
                                <!-- Branch Code -->
                                <span class="text-[11px] font-mono font-bold text-slate-800">{{ branch.branchCode }}</span>
                            </div>
                            <div class="flex items-center gap-2 shrink-0">
                                <!-- Updated At -->
                                <span class="text-[10px] text-slate-400">{{ formatDate(branch.updatedAt) }}</span>
                                <!-- Status Badge -->
                                <span [class]="'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold border shadow-sm whitespace-nowrap ' + getBranchStatusColor(branch.status)">
                                    {{ getBranchStatusLabel(branch.status) }}
                                </span>
                                <!-- Retry Button (Admin, Operator only) -->
                                @if (branch.status === 'ERROR' && authService.hasRole(['Admin', 'Operator'])) {
                                <button (click)="retryBranch(branch.uuid); $event.stopPropagation()"
                                    [disabled]="retryingBranch() === branch.uuid"
                                    class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-all cursor-pointer disabled:opacity-50"
                                    title="Reprocessar filial">
                                    <lucide-icon [img]="icons.RotateCcw"
                                        [class]="'w-3 h-3' + (retryingBranch() === branch.uuid ? ' animate-spin' : '')"></lucide-icon>
                                    @if (retryingBranch() !== branch.uuid) { Retry }
                                </button>
                                }
                            </div>
                        </div>

                        <!-- Expanded: Products + Error Message -->
                        @if (expandedBranch() === branch.uuid) {
                        <div class="mt-2 branch-expand-enter">
                            <!-- Error Message -->
                            @if (branch.status === 'ERROR' && branch.message) {
                            <div class="mb-2 p-2 bg-red-50 border border-red-100 rounded-lg">
                                <p class="text-[10px] text-red-600 leading-relaxed whitespace-pre-wrap">
                                    <lucide-icon [img]="icons.AlertCircle" class="w-2.5 h-2.5 inline-block mr-0.5 align-middle"></lucide-icon>
                                    {{ sanitizeErrorMessage(branch.message) }}
                                </p>
                            </div>
                            }
                            <!-- Products Loading -->
                            @if (branchProductsLoading()) {
                            <div class="flex items-center justify-center py-3 gap-2">
                                <lucide-icon [img]="icons.Loader" class="w-4 h-4 text-indigo-500 animate-spin"></lucide-icon>
                                <span class="text-[10px] text-slate-500">Carregando produtos...</span>
                            </div>
                            } @else if (branchProducts().length > 0) {
                            <!-- Products Table -->
                            <table class="w-full text-left border-collapse">
                                <thead>
                                    <tr class="border-b border-slate-200">
                                        <th class="text-[9px] font-bold uppercase tracking-wider text-slate-500 py-1 px-2">Código</th>
                                        <th class="text-[9px] font-bold uppercase tracking-wider text-slate-500 py-1 px-2 text-right">Quantidade</th>
                                        <th class="text-[9px] font-bold uppercase tracking-wider text-slate-500 py-1 px-2 text-right">Data Entrega</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (product of branchProducts(); track product.uuid) {
                                    <tr class="border-b border-slate-50 last:border-0">
                                        <td class="text-[11px] font-mono font-semibold text-slate-700 py-1 px-2">{{ product.productCode }}</td>
                                        <td class="text-[11px] text-slate-600 py-1 px-2 text-right">{{ formatNumber(product.demandedAmount) }}</td>
                                        <td class="text-[11px] text-slate-500 py-1 px-2 text-right">{{ formatDateOnly(product.referenceDate) }}</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            } @else {
                            <p class="text-[10px] text-slate-400 text-center py-2">Nenhum produto encontrado.</p>
                            }
                        </div>
                        }
                    </div>
                    }
                </div>

                <!-- Filtered count -->
                @if (hasActiveDetailFilters()) {
                <div class="mt-2 text-[10px] text-slate-400 text-center">
                    Exibindo <b class="text-slate-600">{{ filteredBranches().length }}</b> de <b class="text-slate-600">{{ branchCounts().total }}</b> filiais
                </div>
                }
                }
            </div>

            <!-- Footer -->
            <div class="p-3 border-t border-slate-200 shrink-0 flex justify-end">
                <button (click)="closeDetails()"
                    class="px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors cursor-pointer">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- ===================== TOAST ===================== -->
    @if (toast(); as t) {
    <div class="fixed bottom-4 right-4 z-[200] animate-slide-up">
        <div [class]="'flex items-center gap-2 px-4 py-3 rounded-xl shadow-2xl border text-sm font-medium ' +
            (t.type === 'success' ? 'bg-emerald-50 text-emerald-800 border-emerald-200' : 'bg-red-50 text-red-800 border-red-200')">
            <lucide-icon [img]="t.type === 'success' ? icons.CheckCircle : icons.AlertOctagon"
                [class]="'w-4 h-4 shrink-0 ' + (t.type === 'success' ? 'text-emerald-600' : 'text-red-600')"></lucide-icon>
            {{ t.message }}
        </div>
    </div>
    }
</div>
